import { render, staticRenderFns } from "./NavbarTop.vue?vue&type=template&id=0a5d6a0c"
import script from "./NavbarTop.vue?vue&type=script&lang=js"
export * from "./NavbarTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports